import { getApps, initializeApp } from 'firebase/app';
import { addDoc, collection, getFirestore, serverTimestamp } from 'firebase/firestore';

const fallbackConfig = {
  apiKey: 'AIzaSyBuC6K5G4nRNjOwT9nSSJ4Jkph74OW6UXM',
  authDomain: 'tailorwalaapp-81042.firebaseapp.com',
  projectId: 'tailorwalaapp-81042',
};

function getAccountApp() {
  const appName = 'tailorwala-account-requests';
  const existingApp = getApps().find((item) => item.name === appName);
  return existingApp ?? initializeApp(fallbackConfig, appName);
}

export async function submitAccountDeletionRequest(email) {
  const db = getFirestore(getAccountApp());
  return addDoc(collection(db, 'deleteAccountRequests'), {
    email: email.trim().toLowerCase(),
    source: 'website',
    status: 'pending',
    requestedAt: serverTimestamp(),
  });
}
